import React, { useEffect, useState } from 'react';
import axios from '../axiosConfig';
import '../css/modalPerfil.css';
import { handleError, toastError } from '../funciones';
function Notificaciones(props) {

    const [notificaciones, setNotificaciones] = useState([]);

    function cerrarNotificaciones() {
        document.getElementById('notificaciones').classList.add('d-none');
    }
    function redireccionar() {
        if (!localStorage.getItem(process.env.REACT_APP_ES_BORRAR_NOTIFICACION)) {
            let url = window.location.pathname;
            if (url.localeCompare("/actividades"))
                document.location.href = '/actividades';
        }
    }
    function eliminarNotificacion(id) {
        localStorage.setItem(process.env.REACT_APP_ES_BORRAR_NOTIFICACION, "true")
        const params = {
            params: {
                notificacionId: id
            }
        }
        axios
            .delete(process.env.REACT_APP_URL + 'empresa/borrarNotificacion', params)
            .then((res) => {
                //document.getElementById("btnInvitacionEnv" + idEmpresa).classList.add("d-none");
                setNotificaciones(notificaciones => notificaciones.filter(item => item.id.localeCompare(id) !== 0));
                localStorage.removeItem(process.env.REACT_APP_ES_BORRAR_NOTIFICACION);
            })
            .catch(function (error) {
                toastError(handleError(error))
                localStorage.removeItem(process.env.REACT_APP_ES_BORRAR_NOTIFICACION);
            })
    }
    
    

    useEffect(() => {
        if (props.notificaciones !== null) {
            setNotificaciones(props.notificaciones);
        }
        document.addEventListener("click", function (e) {
            //obtiendo informacion del DOM para  
    
            if (!localStorage.getItem(process.env.REACT_APP_ES_BORRAR_NOTIFICACION)) {
               
                var notificaciones = document.getElementById('notificaciones');
                var listaNotificaciones = document.getElementById('listaNotificaciones');
                var but = document.getElementById('botonNotificaciones');
                var clic = e.target;
    
                if (!notificaciones.classList.contains('d-none') && clic != but) {
                    var ocultar = true;
                    for (var x = 0; x < listaNotificaciones.childNodes.length; x++)
                        if (listaNotificaciones.childNodes[x] == clic)
                            ocultar = false;
    
                    if (ocultar)
                        notificaciones.classList.add('d-none');
                }
            }
        }, false);
    }, [props.notificaciones])

    return (
        <>
            <div className='position-absolute z-10 d-none containerNotificaciones text-start' id='notificaciones'>
                <div class="list-group listaNotificaciones" id="listaNotificaciones">
                    <p class="list-group-item mb-0 colorPrincipal text-white textoTablas border-0 encabezadoNotificaciones" aria-current="true">
                        Notificaciones
                        <button type="button" class="btn-close btn-close-white cruzCerrarNotificaciones" onClick={cerrarNotificaciones}></button>
                    </p>
                    {notificaciones.length !== 0 ?

                        <div className='itemsNotificaciones' onClick={redireccionar}>
                            {notificaciones.map(function (elem, i) {
                                return (
                                    <>
                                        <button type="button" class="list-group-item list-group-item-action border-0 postion-relative">
                                            {/*elem.split("<b>").map(function(x, i){
                                    return( 
                                        i % 2 === 1?
                                            <b> {x} </b> 
                                        :
                                            x
                                    )
                                })*/}
                                            {elem.tipo === "CREADA" ?
                                                <>Se <b>creó</b> una reunión con la empresa <b>{elem.empresaEmisoraNombre}</b> en el evento <b>{elem.eventoNombre}</b></>
                                                : elem.tipo === "INVITADO" ?
                                                    <>Recibiste una <b>invitación</b> de la empresa <b>{elem.empresaEmisoraNombre}</b> en el evento <b>{elem.eventoNombre}</b></>
                                                    : elem.tipo === "CANCELADA" ?
                                                        <>Se <b>canceló</b> una reunión con la empresa <b>{elem.empresaEmisoraNombre}</b> en el evento <b>{elem.eventoNombre}</b></>
                                                        : elem.tipo === "REPROGRAMADO" ?
                                                            <>Se <b>reprogramó</b> una reunión con la empresa <b>{elem.empresaEmisoraNombre}</b> en el evento <b>{elem.eventoNombre}</b></>
                                                            :
                                                            <></>
                                            }
                                            <div className="ms-1 cruzBadge position-absolute position-cruz-notificaciones d-none" alt="" onClick={() => eliminarNotificacion(elem.id)} />
                                        </button>
                                    </>
                                )
                            })}

                        </div>

                        :
                        <p className='text-black text-center py-3  mb-0' id='textSinNotif'>No se encontraron Notificaciones</p>
                    }
                    <p className='pt-3 mb-0 pb-3 fw-normal text-center mostrarMobile footerNotificaciones d-none'>

                        <a className="linkNewAge text-black" href='https://new-age.com.ar/'>Created by <span className='fw-bolder text-color-principal'>NewAge</span></a>


                    </p>
                </div>
            </div>
        </>

    );
}


export default Notificaciones;